/**
 * 创建 ai 智能体
 */
export interface CreateAlgoParams {
  name: string;
  description: string;
  /**
   * 提示词
   */
  systemPrompt?: string;
  subjects?: number[];
  sites?: number[];
  /**
   * 是否发布
   */
  published?: boolean;
}

/**
 * 创建 ai 智能体测试任务
 */
export interface CreateAlgoTestParams {
  examSubjectId?: number;
  questionId: number;
  taskId?: number;
  page: number;
}

export interface AlgoData {
  id: number;
  name: string;
  /**
   * 智能体描述信息
   */
  description: string;
  /**
   * 智能体提示词
   */
  systemPrompt: string;
  published: boolean;
  subModel: number;
  subjects: number[];
  user: number;
  sites: number[];
  version?: number;
  /**
   * 智能体的类型
   */
  type?: AlgoTypeEnum;
  /**
   * 是否支持多题
   */
  supportMultiQuestion?: boolean;
}

/**
 * 智能体的类型
 */
export enum AlgoTypeEnum {
  /**
   * 系统自带
   */
  System,
  /**
   * 通用
   */
  General,
  /**
   * 自定义
   */
  Custom,
}

export enum TestStepEnum {
  /**
   * 选择任务
   */
  ChooseTask,
  // 选择题目
  ChooseQuestion,
  /**
   * 测试的结果
   */
  Result,
  /**
   * 测试的结果详情
   */
  ResultDetail,
}

export interface TestDetails {
  detailId: number;
  /**
   * AI评分
   */
  finalScore: number;
  firstName: string;
  id: number;
  /**
   * AI输出结果
   */
  lmOutput: string;
  /**
   * 教师评分
   */
  markScore: number;
  photos: string[];
}

export interface TestResult {
  id: number;
  user: number;
  examSubject: number;
  taskId: number;
  promptId: number;
  customPrompt: string;
  /**
   * 最终的提示词 暂时展示使用。
   */
  finalPrompt?: string;
  questionId: number;
  markType: number;
  /**
   * 状态
   */
  status: AlgoJobStatusEnum;
  statis: TestResultStatis;
  message: string;
  /**
   * 任务名称
   */
  name: string;
  /**
   * 用时为  modifyAt减去createAt
   */
  modifyAt: string;
  createAt: string;
  isShowPrompt?: boolean;
  isLoading?: boolean;
}

/**
 * AI阅卷的进程状态
 */
export enum AlgoJobStatusEnum {
  /**
   * 等待开始阅卷
   */
  JOB_INIT = 0,
  /**
   * 排队中
   */
  JOB_QUEUED = 1,
  /**
   * 运行中
   */
  JOB_RUNNING = 2,
  /**
   * 失败
   */
  JOB_FAILED = 3,
  /**
   * 成功
   */
  JOB_SUCCEED = 200,
  /**
   * 检查失败，纯前端行为。
   */
  JOB_CHECK_FAILED = 406,
}

export interface StatisDetail {
  mean: number;
  count: number;
  /**
   * 中位数
   */
  median: number;
  /**
   * 标准差
   */
  stdDev: number;
  /**
   * 相同评分的数量
   */
  sameMarkCount?: number;
}

export interface TestResultStatis {
  ai: StatisDetail;
  llm: StatisDetail;
  vlm: StatisDetail;
  diff: StatisDetail;
  teacher: StatisDetail;
}